import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { get } from 'lodash';

class VerbRoute extends Component {
    render() {
        const { render, transform = {}, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={(routeProps) => {
                    const transformParams = Object.keys(transform);
                    (transformParams || []).forEach((transformParam) => {
                        if (get(routeProps, `match.params[${transformParam}]`, '')) {
                            const transformFunc = transform[transformParam];
                            routeProps.match.params[transformParam] = transformFunc(
                                routeProps.match.params[transformParam]
                            );
                        }
                    });
                    return <Route render={render} {...rest} />;
                }}
            />
        );
    }
}

VerbRoute.propTypes = {
    transform: PropTypes.object,
    render: PropTypes.any
};

export default VerbRoute;
